import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { IReportFilter } from '../../../utils/interfaces/report-filter';
import { IResponse } from '../../../utils/interfaces/response';

@Injectable({
  providedIn: 'root',
})
export class AnalyticalReportService {
  private readonly URI_API = environment.apiConfig.uri + 'AnalyticalReport';

  constructor(private readonly httpClient: HttpClient) {}

  getAnalyticalReport(filter: IReportFilter): Observable<IResponse<any>> {
    return this.httpClient.post<IResponse<any>>(
      `${this.URI_API}/analytical`,
      filter
    );
  }
}
